import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../Table/ResultTable";
import ResultText from "../ResultText";
import {useUser} from "../../../Context/UserContext";
import EmptyLine from "../../EmptyLine";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import NO_OUT_Component from "../NO_OUT_Component";
import ResultView from "../../V2/ResultView";

export function OP5({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.OP5_OP05.error_id: {
            return (
                <>
                    <ResultText>
                        The WSEL defaults to critical depth at the following {row?.data?.length} cross sections.
                    </ResultText>
                    <EmptyLine />
                    <ResultTable  data={row}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(25)}}>Critical Profiles</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>Invert Slope</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'start', width: HecRasHelper.getWidth(12)}}>{r?.cross_section}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'start', width: HecRasHelper.getWidth(25)}}>{r?.profiles?.join(', ')}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>{r?.slope}</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.OP5_NOOUT01.error_id: {
            return (
                <ResultText>
                    <NO_OUT_Component error={row}/>
                </ResultText>
            )
        }
        case MessageCodes.Internal.OP5_NOOUT02.error_id: {
            return (
                <>
                    <NO_OUT_Component error={row}/>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}